import React, { useContext, useEffect, useState } from "react";
import Header from "../components/header/Header";
import DesktopView from "../components/desktopview/DesktopView";
import Loader from "../components/loader/Loader";
import { useNavigate } from "react-router-dom";
import { SHOW_PIECES } from "../constants/piecesIcon";
import { useCookies } from "react-cookie";
import { MdDateRange } from "react-icons/md";
import MessageModals from "../components/modals/MessageModals";
import globalContext from "../Contexts/GlobalContext";
import { IoArrowDownSharp } from "react-icons/io5";
import { SVG_ICONS } from "../constants/svgIcons";
import BlueLoader from "../components/loader/BlueLoader";
import useRequestHeader from "../hooks/useRequestHeader";
import axios from "axios";
import { SERVERMODE } from "../constants/serverMode";
import { handleServerMode } from "../utils/handleServer";
import { serverErrorMessage } from "../constants/serverMessage";

export default function PayEst() {
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies();
  const contextData = useContext(globalContext);
  const requestHeader = useRequestHeader();
  const [isLoading, setIsLoading] = useState(false);
  const [isViolationItmesOpen, setIsViolationItmesOpen] = useState(true);
  const [isDocumentItmesOpen, setIsDocumentItmesOpen] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const config = {
      headers: requestHeader,
    };
    axios
      .post(`${BASE_URL}/inquiries/status`, {}, config)
      .then((res) => {
        var responseMode = res?.data?.Mode;
        var responseMessage = res?.data?.Message;
        switch (responseMode) {
          case SERVERMODE.REQUEST_OK: {
            var violationWithDetail = res?.data?.Data[0];
            var violationWithoutDetail = res?.data?.Data[1];
            var negativeGrade = res?.data?.Data[2];
            var insuranceThird = res?.data?.Data[3];

            setCookies(
              "total_violation_price",
              violationWithoutDetail["price"]
            );
            setCookies(
              "detailing_violation_price",
              violationWithDetail["price"]
            );
            setCookies("certificate_inquiry_price", negativeGrade["price"]);
            setCookies("insurance_inquiry_price", insuranceThird["price"]);

            setIsLoading(false);
            break;
          }
          case SERVERMODE.REQUEST_ERROR: {
            contextData.setIsToastOpen(true);
            contextData.setToastMessage(serverErrorMessage());
            setIsLoading(false);
            break;
          }
          default: {
            handleServerMode(
              responseMode,
              responseMessage,
              contextData,
              cookies,
              removeCookies,
              navigate
            );
            setIsLoading(false);
          }
        }
      })
      .catch((err) => {
        contextData.setIsToastOpen(true);
        contextData.setToastMessage("ارتباط با سرور دچار مشکل شده است");
        setIsLoading(false);
      });
  }, []);

  return (
    <>
      <div className="hidden min-[1024px]:block ">
        <DesktopView />
      </div>
      <div
        className="absolute w-full top-0 bottom-0 flex flex-col items-center justify-between bg-[#153038] min-[1024px]:hidden "
        onClick={() => {
          //   if (isSupportRequest === "true") {
          //     setIsSupportRequest("false");
          //   }
        }}
      >
        <Header relt="relative" />
        {contextData.isToastOpen && (
          <MessageModals
            setIsOpen={contextData.setIsToastOpen}
            message={contextData.toastMessage}
          />
        )}

        <div
          className={`w-[85vw] h-full flex flex-col items-start justify-start  gap-y-[2vw]`}
        >
          <div className="w-full flex flex-col items-center justify-center p-[2vw] mt-[12vw] gap-y-[1vw]">
            <p className="font-font_primary_A text-[5.5vw] text-white font-bold">
              خدمان پرداختی و استعلامی خودرو
            </p>
            <p className="font-font_primary_A text-[3vw] text-white font-extralight">
              خدمات مورد نظر خودرو خود را از لیست زیر انتخاب کنید
            </p>
          </div>

          {isLoading ? (
            <div className="w-full flex-1 flex items-center justify-center">
              <BlueLoader position="relative" width={15} />
            </div>
          ) : (
            <div className="w-full overflow-y-scroll flex flex-col mt-[4vw] mb-[20vw] ">
              <div
                className="w-full flex items-center justify-between bg-color-primary-B font-font_primary_A font-bold rounded-[1.8vw] text-[3vw] py-[1.5vw] px-[2vw]"
                onClick={() => {
                  setIsViolationItmesOpen((prev) => !prev);
                }}
              >
                <span>استعلام خلافی خودرو</span>
                <span className={`${isViolationItmesOpen ? "" : "rotate-90"}`}>
                  <IoArrowDownSharp size={16} />
                </span>
              </div>
              <div className={`${isViolationItmesOpen ? "" : "hidden"}`}>
                <div
                  className="relative w-full min-h-[20vw] flex items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[2vw] px-[2vw] mt-[4vw]"
                  onClick={() => {
                    navigate("/violation");
                    setCookies("violation_mode", "total");
                  }}
                >
                  <div className="">
                    {SVG_ICONS(
                      "total-violation",
                      "#9E9B96",
                      "14.5vw",
                      "14.5vw"
                    )}
                  </div>
                  <div className="h-full flex-1 flex flex-col items-center justify-center">
                    <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw]  ">
                      استعلام خلافی تجمیعی
                    </span>
                    <span className="w-full flex items-center justify-start  font-font_primary_A text-[2.5vw]   text-color-primary-C3">
                      مشاهده و پرداخت آنی به صورت تجمیعی با پلاک خودرو
                    </span>
                  </div>
                </div>

                <div
                  className="relative w-full min-h-[20vw] flex items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[2vw] px-[2vw] mt-[4vw]"
                  onClick={() => {
                    navigate("/violation");
                    setCookies("violation_mode", "detailing");
                  }}
                >
                  <div className="">
                    {SVG_ICONS(
                      "detailing-violation",
                      "#9E9B96",
                      "14.5vw",
                      "14.5vw"
                    )}
                  </div>
                  <div className="h-full flex-1 flex flex-col items-center justify-center">
                    <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw]  ">
                      استعلام خلافی با جزئیات
                    </span>
                    <span className="w-full flex items-center justify-start  font-font_primary_A text-[2.5vw]   text-color-primary-C3">
                      مشاهده جزئیات کامل خلافی با کد ملی و موبایل مالک
                    </span>
                  </div>
                </div>

                <div
                  className="relative w-full min-h-[20vw] flex items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[2vw] px-[2vw] mt-[4vw]"
                  onClick={() => {
                    navigate("/payBill");
                  }}
                >
                  <div className="">
                    {SVG_ICONS("pay-bill", "#9E9B96", "14.5vw", "14.5vw")}
                  </div>
                  <div className="h-full flex-1 flex flex-col items-center justify-center">
                    <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw]  ">
                      پرداخت خلافی با شناسه
                    </span>
                    <span className="w-full flex items-center justify-start  font-font_primary_A text-[2.5vw]   text-color-primary-C3">
                      پرداخت با شناسه قبض و شناسه پرداخت
                    </span>
                  </div>

                  <span className="absolute top-[3vw] left-[3vw] text-[2vw] font-font_primary_A font-bold text-color-primary-B">
                    بدون کارمزد
                  </span>
                </div>
              </div>

              {/* <div
                className="w-full flex items-center justify-between bg-color-primary-B font-font_primary_A font-bold rounded-[1.8vw] text-[3vw] py-[1.5vw] px-[2vw] mt-[7vw]"
                onClick={() => {
                  setIsDocumentItmesOpen((prev) => !prev);
                }}
              >
                <span>استعلام مدارک</span>
                <span className={`${isDocumentItmesOpen ? "" : "rotate-90"}`}>
                  <IoArrowDownSharp size={16} />
                </span>
              </div>
              <div className={`${isDocumentItmesOpen ? "" : "hidden"}`}>
                <div
                  className="relative w-full min-h-[20vw] flex items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[2vw] px-[2vw] mt-[4vw]"
                  onClick={() => {}}
                >
                  <div className="">
                    {SVG_ICONS(
                      "certificate-inquiry",
                      "#9E9B96",
                      "14.5vw",
                      "14.5vw"
                    )}
                  </div>
                  <div className="h-full flex-1 flex flex-col items-center justify-center">
                    <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw]  ">
                      استعلام نمره منفی گواهینامه
                    </span>
                    <span className="w-full flex items-center justify-start  font-font_primary_A text-[2.5vw]   text-color-primary-C3">
                      استعلام نمره منفی گواهینامه با شماره گواهینامه
                    </span>
                  </div>
                </div>

                <div
                  className="relative w-full min-h-[20vw] flex items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[2vw] px-[2vw] mt-[4vw]"
                  onClick={() => {}}
                >
                  <div className="">
                    {SVG_ICONS(
                      "insurance-inquiry",
                      "#9E9B96",
                      "14.5vw",
                      "14.5vw"
                    )}
                  </div>
                  <div className="h-full flex-1 flex flex-col items-center justify-center">
                    <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw]  ">
                      استعلام تاریخ اتمام بیمه شخص ثالث
                    </span>
                    <span className="w-full flex items-center justify-start  font-font_primary_A text-[2.5vw]   text-color-primary-C3">
                      استعلام تاریخ اتمام بیمه شخص ثالث با کد ملی مالک و کد
                      یکتای بیمه نامه
                    </span>
                  </div>
                </div>
              </div> */}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
